import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { DEPRECATED_Typography } from "../DEPRECATED_Typography/Typography";
import styles from "./IconBanner.module.scss";
export const IconBanner = ({ imageUrl, title, description, className, type = "small" }) => {
    const style = classNames(styles.iconBanner, className, {
        [styles.iconSmall]: type === "small",
        [styles.iconLarge]: type === "large",
        [styles.iconXLarge]: type === "xlarge",
    });
    const titleConfig = {
        xlarge: {
            color: "black",
            weight: "medium",
            type: "xlarge-title",
        },
        large: {
            color: "tertiary",
            type: "small-title",
        },
        small: {
            color: "tertiary",
            type: "large-text",
        },
    };
    const isExtraLarge = type === "xlarge";
    const descriptionTextType = isExtraLarge ? "small-title" : "text";
    const descriptionTextColor = isExtraLarge ? "black" : "tertiary";
    return (_jsxs("div", { "data-testid": "iconBanner", className: style, children: [_jsx("figure", { className: styles.iconSection, style: {
                    "--imgSrc": `url("${imageUrl}")`,
                }, children: !isExtraLarge && _jsx("img", { "data-testid": "iconBannerImg", className: styles.iconImage, src: imageUrl, alt: "" }) }), _jsx(DEPRECATED_Typography, { dataTestid: "iconBannerTitle", ...titleConfig[type], className: styles.iconTitle, children: title }), description && (_jsx(DEPRECATED_Typography, { dataTestid: "iconBannerDescription", color: descriptionTextColor, type: descriptionTextType, className: styles.iconDescription, children: description }))] }));
};
//# sourceMappingURL=IconBanner.js.map